define('GameDayCore/GDModel/ValueObjects/Plays/PlaysFileDefense',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(PlaysFileDefense);

	function PlaysFileDefense($data) {
		var vo = VO.ensureVO(this, PlaysFileDefense),
			data = $data,
			fielders = data.man;

		vo.id = data.id;
		vo.type = data.type;
		vo.first = getDefense("1b", fielders);
		vo.second = getDefense("2b", fielders);
		vo.third = getDefense("3b", fielders);
		vo.short = getDefense("ss", fielders);
		vo.pitcher = getDefense("p", fielders);
		vo.catcher = getDefense("c", fielders);
		vo.left = getDefense("lf", fielders);
		vo.center = getDefense("cf", fielders);
		vo.right = getDefense("rf", fielders);
	}

	function getDefense($pos, fielders) {
		try {
			for (var i = 0, len = fielders.length; i < len; i++) {
				if (fielders[i].pos == $pos) {
					return fielders[i];
				}
			}
		} catch (e) {

			return null;
		}
	}

	return PlaysFileDefense;
});
